import React from 'react';
import CollectBuyListContainer from '../../containers/collects_buys/CollectBuyListContainer';

const CollectBuyListPage = () => {
  return <CollectBuyListContainer />;
};

export default CollectBuyListPage;
